<template>
  <div>
    <!-- 캡쳐시 화면 전체 덮는 레이어 -->
    <div v-if="captureMode" class="cover"></div>

    <div v-if="request && nowProgress" class="d-2304" ref="capture">
      <div class="header-title">
        {{ headerTitle }}
      </div>

      <div class="px-3" v-if="!captureMode">
        <v-progress-linear
          class="mb-8"
          :value="progressLength"
          color="black"
          background-color="#eee"
          height="2"
        ></v-progress-linear>
      </div>

      <component
        :key="nowProgress.id"
        :is="nowProgress.component"
        :request="request"
        :loading="submitLoading"
        @success="submit"
      />
    </div>
  </div>
</template>

<script>
import { defaultApi } from '@/plugins/api/defaultApi'
import { sleep } from '@/util'
import html2canvas from 'html2canvas'
import { mapMutations, mapState } from 'vuex'

export default {
  props: ['uuid'],
  data() {
    return {
      ready: false,
      request: null,
      files: {
        loading: false,
        data: null,
      },
      submitLoading: false,
      progresses: [
        {
          id: 0,
          title: '사업참여신청서',
          component: () => import('./application/ApplicationForm.vue'),
        },
        {
          id: 1,
          title: '자가진단표',
          component: () => import('./application/SelfDiagnosisChart.vue'),
        },
      ],
    }
  },
  watch: {
    /**
     * 진행 단계에 따라 헤더 제목 세팅
     */
    nowProgress: {
      handler(v) {
        if (v) {
          this.$nextTick(() => this.$vuetify.goTo(0))
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState('ui', ['captureMode']),

    headerTitle() {
      return this.nowProgress.title
    },
    /**
     * 헤더 진행도(%) 막대 값 계산
     *
     * @param index 현재 단계 번호(0부터 시작)
     * @param length 총 단계 개수
     */
    progressLength() {
      if (!this.nowProgress) {
        return 0
      }
      const tabLength = this.progresses.length
      const tabSize = this.nowProgress.id + 1
      const percentage = (tabSize / tabLength) * 100
      return percentage - 12 // 마지막 단계에서 약간 모자라보이게
    },

    /**
     * 작성해야할 계약서
     */
    nowProgress() {
      if (!this.files.data) {
        return this.progresses[0]
      }
      // 파일 목록에 없는 단계를 찾는다
      return this.progresses.find((progress) => {
        return !this.files.data.find((file) => file.title === progress.title)
      })
    },
  },
  mounted() {
    this.ready = true
  },
  async created() {
    // 신청 조회
    const { data } = await defaultApi.getLoansRequestDetail(this.uuid)
    this.request = data

    await this.fetchData()
  },
  methods: {
    ...mapMutations('ui', ['setCaptureMode']),

    /**
     * 파일 목록 조회
     */
    async fetchData() {
      try {
        this.files.loading = true
        const { data } = await defaultApi.getLoansRequestFiles(this.uuid)
        this.files.data = data

        // 모든 신청서가 다 작성된 경우
        if (
          this.progresses.every((progress) => {
            return this.files.data.find((file) => file.title === progress.title)
          })
        ) {
          if (this.request.status === 'init') {
            let status = 'calculating_limits' // 한도 산출중
            if (this.request.initOfferId) {
              status = 'in_review' // 심사
            }
            await defaultApi.putLoansRequest(this.request.uuid, {
              status,
            })
          }

          // await this.$swal.fire({
          //   html: `<p class="custom-alert__text">
          //     신청서 작성이 완료되었습니다.
          //   </p>`,
          //   confirmButtonText: '확인',
          //   customClass: { container: 'custom-alert2', actions: 'single' },
          // })

          // 모든 신청서 작성 완료된 경우 success
          this.$emit('success')
        }
      } finally {
        this.files.loading = false
      }
    },

    /**
     * 화면 캡쳐
     */
    async capture() {
      await sleep(1500)

      const element = this.$refs.capture
      const canvas = await html2canvas(element, {
        x: 0,
        y: 0,
        scale: 1,
      })

      const blob = await new Promise((resolve) => canvas.toBlob(resolve))
      this.testViewUrl = window.URL.createObjectURL(blob)
      return blob
    },
    async submit() {
      console.log('submit', this.submitLoading, this.captureMode)
      if (this.submitLoading || this.captureMode) {
        return
      }
      
      try {
        console.log('submit try', this.submitLoading, this.captureMode)
        this.setCaptureMode(true)
        this.submitLoading = true

        const { isConfirmed } = await this.$swal.basic.confirm('서류를 제출 하시겠습니까?')
        if (isConfirmed === true) {
        
          const blob = await this.capture()
          await defaultApi.postLoansRequestFile(
            this.uuid,
            blob,
            this.nowProgress.title,
            this.nowProgress.title + '.png',
          )

          this.setCaptureMode(false)
          // await this.$swal.fire({
          //   html: `<p class="custom-alert__text">
          //     서류 제출이 완료되었습니다.
          //   </p>`,
          //   confirmButtonText: '확인',
          //   customClass: { container: 'custom-alert2', actions: 'single' },
          // })
          await this.fetchData()
        }
      } finally {
        this.setCaptureMode(false)
        this.submitLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
form > div:not(:last-child) {
  margin-bottom: 20px;
}
.cover {
  background-color: transparent;
  position: fixed;
  width: 100%;
  height: 120%;
  top: 0;
  z-index: 3;
  touch-action: none;
}

.header-title {
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 900;
}
</style>
